import React from 'react';
import { motion } from 'framer-motion';
import { NeonButton } from './NeonButton';
export const FinalCTA: React.FC = () => {
  return <section className="py-32 relative z-10 overflow-hidden" data-id="element-49">
      {/* Background glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-neon-blue/10 blur-[100px] rounded-full pointer-events-none" data-id="element-50" />

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-52">
          <h2 className="text-4xl md:text-6xl font-bold mb-10 leading-tight" data-id="element-53">
            Tu negocio merece verse{' '}
            <span className="text-neon-blue text-glow" data-id="element-54">profesional</span>
          </h2>
          <NeonButton href="https://wa.me/5493416660996" className="text-xl px-12 py-6" data-id="element-55">
            Consultar por WhatsApp
          </NeonButton>
        </motion.div>
      </div>
    </section>;
};